/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import { NavMenuGlobal } from "./NavMenu";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import AppTopTools from "./AppTopTools";
import { qreq } from "../shared/qrequest";
import FormInput from "./FormInput";
import L from "./Lang";
import AppFormActions from "./AppFormActions";
import Icon from "./Icon";
import { PrintGlobal } from "./PrintView";
import Globals from "../shared/Globals";

class OnHand extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            query: {},
            categories: []
        };
    }

    async componentDidMount() {
        NavMenuGlobal.setPath('On Hand');
        let list = await this.load();
        let categories = await this.loadCategories();
        this.setState({ groupList: this.groupList(list, categories) });
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/inventory/onhand/list');
            if (j.list) {
                this.setState({ list: j.list });
                return j.list;
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadCategories = async () => {
        try {
            let j = await qreq.getAsync('/api/category/list');
            if (j.list) {
                this.setState({ categories: j.list });
                return j.list;
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    filterCategory = (v) => {
        let category = this.state.categories.find(x => x.id === parseInt(v));
        if (category)
            this.setState({ categoryFilter: category });
        else
            this.setState({ categoryFilter: null });
    }

    groupList = (items, categories) => {
        let groupedList = [];

        categories.forEach(cat => {
            groupedList.push({
                name: cat.name,
                list: items.filter(x => x.sa_item === cat.line_code),
                total: items.filter(x => x.sa_item === cat.line_code).reduce((t, x) => t + x.onHand, 0)
            });
        });

        return groupedList;
    }


    render() {
        let list = [...(this.state.list || [])];

        if (this.state.search) {
            list = list.filter(x => (x.item_num.toLowerCase() === this.state.search.toLowerCase().trim()
                || x.desc_1.toLowerCase().indexOf(this.state.search.toLowerCase().trim()) >= 0
                || x.categoryName.toLowerCase().indexOf(this.state.search.toLowerCase().trim()) >= 0));
        }

        if (this.state.categoryFilter) {
            list = list.filter(x => x.sa_item.toLowerCase() === this.state.categoryFilter.line_code.toLowerCase())
        }

        let total = list.reduce((t, x) => t + x.onHand, 0);

        return <div className="container-fluid">
            <AppTopTools>
                <FormInput model={this.state.query} name="category" label="Category" type="select" options={this.state.categories} onChange={this.filterCategory}
                    labelAsPlaceholder />
            </AppTopTools>
            <div className="overflow-hidden">
                {this.state.categoryFilter ? <ul className="list-group">
                    {list.map((i, idx) => <li key={idx} className="list-group-item d-flex justify-content-between">
                        <div>
                            <div>{i.desc_1}</div>
                            <div className="text-info">{i.item_num}</div>
                        </div>
                        <div className={i.onHand > 0 ? "text-success" : "text-danger"}>
                            <strong>{i.onHand}</strong>
                        </div>
                    </li>)}
                    <li className="list-group-item d-flex justify-content-between bg-light">
                        <div>
                            TOTAL
                        </div>
                        <div className={total > 0 ? "text-success" : "text-danger"}>
                            <strong>{total}</strong>
                        </div>
                    </li>
                </ul> : <div>{this.state.groupList?.map((g, gdx) => <div key={gdx}>
                    <h2 className="mt-3 ms-1 fw-bold">{g.name}</h2>
                    <ul className="list-group">
                        {g.list.length === 0 ? <div className="text-muted"><L>No items in this category.</L></div>
                            : g.list.map((i, idx) => <li key={idx} className="list-group-item d-flex justify-content-between">
                                <div>
                                    <div>{i.desc_1}</div>
                                    <div className="text-info">{i.item_num}</div>
                                </div>
                                <div className={i.onHand > 0 ? "text-success" : "text-danger"}>
                                    <strong>{i.onHand}</strong>
                                </div>
                            </li>)}
                        <li className="list-group-item d-flex justify-content-between bg-light">
                            <div>
                                TOTAL
                            </div>
                            <div className={g.total > 0 ? "text-success" : "text-danger"}>
                                <strong>{g.total}</strong>
                            </div>
                        </li>
                    </ul>
                </div>)}

                    <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between bg-light fw-bolder">
                            <div>
                                GRAND TOTAL
                            </div>
                            <div className={total > 0 ? "text-success" : "text-danger"}>
                                <strong>{total}</strong>
                            </div>
                        </li>
                    </ul>

                </div>}

            </div>
        </div>;
    }
}

export default withParamsAndNavigate(OnHand);